class ShareButton extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.share-button__trigger');
    this.fallback = this.querySelector('.share-button__fallback');
    this.copyButton = this.querySelector('.share-button__copy');
    this.input = this.querySelector('.share-button__input');
    this.message = this.querySelector('.share-button__message');

    this.url = this.dataset.shareUrl || window.location.href;
  }

  connectedCallback() {
    if (!this.trigger) return;

    this.trigger.addEventListener('click', () => {
      if (navigator.share) {
        navigator.share({
          url: this.url,
          title: document.title
        });
      } else {
        this.openFallback();
      }
    });

    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => this.copy());
    }
  }

  openFallback() {
    this.fallback.classList.remove('hidden');
    this.input.focus();
    this.input.select();
  }

  copy() {
    navigator.clipboard.writeText(this.url).then(() => {
      this.message.classList.remove('hidden');
      this.copyButton.setAttribute('disabled', 'disabled');
    });
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton);
}
